


export const parentAcccountId = '252855055641'
export const parentHostedZoneName = 'iotv.link'
export const parentAccountHostedZoneId ='Z037408026LR1VED1RWZN'


